module.exports = __webpack_public_path__ + "img/beamian-logo-white.png";